/**
 * Shim do serviço de log de erros — delega ao logger central (window.AgndLogger), provido pelo
 * script console-logger.js incluído no <head> do index.html (o mesmo de todos os apps Agendário).
 *
 * Mantém a assinatura `logError(error, pageUrl, context)` usada pelos call sites existentes
 * (ErrorBoundary, interceptor do api.js, useQueryCRUD, supportService) — assim a centralização
 * não exige tocar em nenhum deles. O token é configurado no logger central via authService.
 */
class ErrorLogService {
  /**
   * @param {Error|string} error
   * @param {string|null} pageUrl  - ignorado (o logger central usa location.href)
   * @param {object|null} context  - componentStack, detectedExtensions, contexto de API, etc.
   * @returns {Promise<void>} sempre resolvido (call sites usam `.catch(() => {})`)
   */
  logError(error, pageUrl = null, context = null) {
    try {
      if (typeof window !== 'undefined' && window.AgndLogger) {
        window.AgndLogger.log(error, context);
      }
    } catch (_) {
      // nunca propaga
    }
    return Promise.resolve();
  }
}

export const errorLogService = new ErrorLogService();
